import Swiper from 'swiper';

new Swiper('.kn-post-list-3 .swiper-container', {
  slidesPerView: 'auto',
  freeMode: true,
  centerInsufficientSlides: true,
});

$('.filter-list .filter').click(function() {

  if ($(this).attr('data-cat') === 'all')
    filterCategory();
  else
    filterCategory($(this).attr('data-cat'));

});

function filterCategory(cat) {

  // reset all hovers hover
  $('.filter-list .filter').parent().removeClass('active');

  // set the correct hover
  $('.filter-list .filter').filter('[data-cat="' + cat + '"]').parent().addClass('active');

  // reset cats
  $('.posts-list .post').removeClass('active');

  // filter the categories (by id) by adding .active
  if (cat)
    $('.posts-list .post').filter('[data-cat="' + cat + '"]').addClass('active');
  else
    $('.posts-list .post').addClass('active');
}

filterCategory();
